import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG } from '../../DashboardBirdview.constants.qa'

import SettingsIcon from '../../../../icons/settings.svg'

function BirdviewChartCatalogButton({ anchorRef, isOpen, onClick }) {
  const { t } = useTranslation()

  return (
    <Button.Outlined
      isGrey
      beforeIconProps={{ Icon: SettingsIcon }}
      elementRef={anchorRef}
      height={BUTTON_HEIGHT_32}
      isActive={isOpen}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG}
      tooltip={t('DashboardBirdview.ChartCatalogTooltipKey')}
      onClick={onClick}
    />
  )
}

export default BirdviewChartCatalogButton
